// @flow

import _ from 'lodash/fp';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom';
import {
  reset,
  fetchWorkerType,
  updateWorkerType,
  createWorkerType,
  clearWorkerType,
} from '../../actions/workerTypeView';
import {touch, isValid, getFormValues, reset as resetForm} from 'redux-form';
import {setDirty} from '../../actions/form';
import SaveMenu from '../../components/SaveMenu/SaveMenu';
import WorkerTypeForm from '../../components/WorkerTypeForm/WorkerTypeForm';
import ServerError from '../../components/ServerError/ServerError';
import LoadingIndicator from '../../components/LoadingIndicator/LoadingIndicator';
import validator from '../../helpers/validator';
import ActionConfirmation from '../ActionConfirmation/ActionConfirmation';
import Navigation from '../../components/Navigation/Navigation';
import DisableContent from '../../components/DisableContent/DisableContent';

const validation = {
  name: {rule: 'string|required', label: 'Namn'},
};

export type Props = {
  setDirty: Function,
  reset: Function,
  touch: Function,
  resetForm: Function,
  workerTypeFormValues?: any,
  workerTypeFormIsValid?: boolean,
  isDirty: boolean,
  fetchWorkerType: Function,
  updateWorkerType: Function,
  createWorkerType: Function,
  clearWorkerType: Function,
  isFetching: boolean,
  prevPath: string,
  workerType?: any,
  params: any,
  error?: any,
  workerTypes: any[],
};

class WorkerTypeContainer extends Component<Props> {
  props: Props;

  componentWillMount() {
    const {params: {id}} = this.props;
    if (id) {
      this.props.fetchWorkerType(id);
    }
  }

  componentWillUnmount() {
    this.props.clearWorkerType();
  }

  setDirty() {
    const {
      setDirty,
      isDirty,
    } = this.props;

    if (!isDirty) {
      setDirty(true);
    }
  }

  reset() {
    const {
      setDirty,
      reset,
      resetForm,
    } = this.props;
    reset();
    resetForm('workerType');
    setDirty(false);
  }

  save() {
    const {
      workerTypeFormValues,
      touch,
      workerTypeFormIsValid,
      workerType,
      updateWorkerType,
      createWorkerType,
    } = this.props;
    const workerTypeKeys = _.keys(validation);
    touch('workerType', ...workerTypeKeys);
    if (!workerTypeFormIsValid) {
      return;
    }

    if (!workerType) {
      createWorkerType(workerTypeFormValues);
    } else {
      updateWorkerType(workerType.id, workerTypeFormValues);
    }
  }

  render() {
    const {
      isDirty,
      params: {id},
      workerType,
      error,
      isFetching,
      updateWorkerType,
      prevPath,
      workerTypes,
      clearWorkerType,
      fetchWorkerType,
    } = this.props;

    return (
      <div className="relative">
        <div className="row align-justify align-middle content-header">
          <div className="column shrink">
            <div className="row no-row-margins align-middle">
              <Navigation
                current={workerType}
                list={workerTypes}
                prevPath={prevPath}
                clear={clearWorkerType}
                fetchData={fetchWorkerType} />
              <div className="content-title">
                {(workerType && workerType.name) || 'Ny yrkeskategori'}
              </div>
            </div>
          </div>
          <div className="column shrink horizontal-button-list">
            {workerType &&
              <DisableContent disabled={isDirty}>
                <ActionConfirmation
                  id="archiveWorkerType"
                  className="secondary button"
                  message={`Vill du verkligen ${workerType.archived ? 'av' : ''}arkivera den här yrkeskategorien?`}
                  buttonText={workerType.archived ? 'Avarkivera' : 'Arkivera'}
                  action={() => updateWorkerType(workerType.id, {archived: !workerType.archived})} />
              </DisableContent>
            }
          </div>
        </div>
        <LoadingIndicator isLoading={isFetching} />
        <ServerError error={error} />
        <div className="content-section box">
          {id ?
            <WorkerTypeForm
              initialValues={workerType}
              onUserChange={() => this.setDirty()}
              validate={values => validator(validation, values)} />
            :
            (workerType ?
              <Redirect to={prevPath} />
              :
              <WorkerTypeForm
                onUserChange={() => this.setDirty()}
                validate={values => validator(validation, values)} />
            )
          }
        </div>
        {isDirty &&
          <SaveMenu
            isLoading={isFetching}
            onDiscard={() => this.reset()}
            onSave={() => this.save()} />
        }
      </div>
    );
  }
}

const mapStateToProps = ({
  workerTypeView: {
    active: workerType,
    error,
    isDirty,
    isFetching,
  },
  workerTypeList: {
    filteredList: workerTypes,
  },
  form,
}) => ({
  error,
  isDirty,
  isFetching,
  workerType,
  workerTypeFormIsValid: isValid('workerType')({form}),
  workerTypeFormValues: getFormValues('workerType')({form}),
  workerTypes,
});

const mapDispatchToProps = dispatch => ({
  setDirty: dirty =>
    dispatch(setDirty(dirty, 'workerType')),
  resetForm: form =>
    dispatch(resetForm(form)),
  reset: () =>
    dispatch(reset()),
  touch: (form, ...fields) =>
    dispatch(touch(form, ...fields)),
  fetchWorkerType: id =>
    dispatch(fetchWorkerType(id)),
  updateWorkerType: (id, data) =>
    dispatch(updateWorkerType(id, data)),
  createWorkerType: data =>
    dispatch(createWorkerType(data)),
  clearWorkerType: () =>
    dispatch(clearWorkerType()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WorkerTypeContainer);



// WEBPACK FOOTER //
// ./src/containers/WorkerTypeContainer/WorkerTypeContainer.js